module.exports = __webpack_public_path__ + "assets/blob-4.42a79a1c.svg";